import { Provider } from '@angular/core';

import { applyToJobShiftsProvider } from './apply-to-job-shifts.provider';
import { cancelJobShiftsProvider } from './cancel-job-shifts.provider';
import { provideJobCreationFlow } from './create-job-flow.provider';
import { provideCreateJobService } from './create-job-service.provider';
import { provideEstimateJobService } from './estimate-job-service.provider';
import { provideGetGuardJobDetails } from './provide-get-guard-job.details';
import { provideGetGuardShiftDetails } from './provide-get-guard-shift-details';

/**
 * Provides all job-related services for dependency injection.
 *
 * This function aggregates providers from multiple job-related services into a single array,
 * making it easier to include all necessary job services in components that need them.
 * It includes providers for:
 * - Applying to job shifts
 * - Cancelling job shifts
 * - Job creation flow
 * - Creating jobs
 * - Estimating job rates
 * - Getting guard job details
 *
 * @returns An array of providers for all job-related services
 */
export const provideJobServices = (): Provider[] => {
    return [
        ...applyToJobShiftsProvider(),
        ...cancelJobShiftsProvider(),
        ...provideJobCreationFlow(),
        ...provideCreateJobService(),
        ...provideEstimateJobService(),
        ...provideGetGuardJobDetails(),
        ...provideGetGuardShiftDetails()
    ];
};
